export default __webpack_public_path__ + "static/media/messages.56d312f9.jpg";